import React from "react";
import Skeleton from "@mui/material/Skeleton";
import Box from "@mui/material/Box";

/** Shimmer rows for the conversation list (left column). */
export function ConversationListSkeleton({ rows = 8 }) {
  return (
    <Box sx={{ px: 1.5, py: 1 }}>
      {Array.from({ length: rows }).map((_, i) => (
        <Box key={i} sx={{ display: "flex", gap: 1.25, py: 1.25, alignItems: "center" }}>
          <Skeleton variant="circular" width={40} height={40} />
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Skeleton variant="text" width="75%" height={18} sx={{ mb: 0.5 }} />
            <Skeleton variant="text" width="45%" height={14} />
          </Box>
        </Box>
      ))}
    </Box>
  );
}

/** Skeleton bubbles for the message thread (right column). */
export function ChatThreadSkeleton() {
  return (
    <Box
      sx={{
        flex: 1,
        minHeight: 0,
        overflow: "hidden",
        px: 2,
        py: 1.5,
        background: "#f8fafc",
        display: "flex",
        flexDirection: "column",
        gap: 1.5,
      }}
    >
      <Skeleton variant="rounded" width={120} height={22} sx={{ alignSelf: "center", borderRadius: 2 }} />
      <Skeleton variant="rounded" width="72%" height={56} sx={{ alignSelf: "flex-start", borderRadius: 2 }} />
      <Skeleton variant="rounded" width="68%" height={48} sx={{ alignSelf: "flex-end", borderRadius: 2 }} />
      <Skeleton variant="rounded" width="78%" height={64} sx={{ alignSelf: "flex-start", borderRadius: 2 }} />
      <Skeleton variant="rounded" width="55%" height={44} sx={{ alignSelf: "flex-end", borderRadius: 2 }} />
      <Skeleton variant="rounded" width="70%" height={52} sx={{ alignSelf: "flex-start", borderRadius: 2 }} />
    </Box>
  );
}

/** Skeleton for student / contact details (middle column). */
export function StudentPanelSkeleton() {
  return (
    <Box sx={{ p: 2, height: "100%" }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
        <Skeleton variant="circular" width={36} height={36} />
        <Box sx={{ flex: 1 }}>
          <Skeleton variant="text" width="80%" height={22} />
          <Skeleton variant="text" width="50%" height={16} />
        </Box>
      </Box>
      <Skeleton variant="text" width="100%" height={14} sx={{ mb: 1 }} />
      <Skeleton variant="text" width="90%" height={14} sx={{ mb: 1 }} />
      <Skeleton variant="text" width="70%" height={14} sx={{ mb: 2 }} />
      <Skeleton variant="rounded" width="100%" height={36} sx={{ mb: 1.5, borderRadius: 1 }} />
      <Skeleton variant="rounded" width="100%" height={72} sx={{ borderRadius: 1 }} />
    </Box>
  );
}

/** Header above the thread when conversation detail is still loading. */
export function ChatHeaderSkeleton() {
  return (
    <Box sx={{ px: 2, py: 1.25, borderBottom: "1px solid #e2e8f0", display: "flex", flexDirection: "column", gap: 0.75 }}>
      <Skeleton variant="text" width="45%" height={22} />
      <Skeleton variant="text" width="30%" height={16} />
    </Box>
  );
}

/** Thin bar for composer / AI row while messages load. */
export function ComposerRowSkeleton() {
  return (
    <Box sx={{ px: 1.5, py: 1, borderTop: "1px solid #e2e8f0", display: "flex", gap: 1 }}>
      <Skeleton variant="rounded" height={40} sx={{ flex: 1, borderRadius: 2 }} />
      <Skeleton variant="rounded" width={44} height={40} sx={{ borderRadius: 2 }} />
    </Box>
  );
}
